export default "__VITE_ASSET__mYrfb9Yl__"